import BaseService from './baseService';
import cloneDeep from 'lodash/cloneDeep'

class User extends BaseService {
  async me(opts = {}) {
    this.endPoint = '/me';
    return this.get(opts);
  }
	async getUsers(page,opts = {}) {
    this.endPoint = '/users?jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
	async getUserById(id,opts = {}) { 
		this.endPoint = '/users/' + id;
		return this.get(opts);
  }
  async getUserByName(payload,opts={}){
    this.endPoint = `/search-by-name?q=${payload.q}`;
    return this.get(opts);
  }
	async getUsersCompany(page,opts = {}) {
		this.endPoint = '/users-by-company?jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
	async getUsersUnverified(opts = {}) {
		this.endPoint = '/search-unverified-users';
		return this.get(opts);
  }
	async getUsersByEmailOrPhone(query, opts = {}) {
		this.endPoint = '/search-by-email-phone?q=' + query;
		return this.get(opts);
  }
	async getRoles(opts = {}) {
		this.endPoint = '/role';
		return this.get(opts);
  }
  async roleUnverified(opts = {}) {
		this.endPoint = '/roleUnverified';
		return this.get(opts);
  }
  
  async createUser(payloadUser){
    this.endPoint = '/users';
    
    return await this.post(payloadUser); 
  }
  async updateUser(payloadUser,opts={}){
    this.endPoint = '/users';
    return await this.put(payloadUser,opts); 
  }
  async activatedUser(id,opts={}){
    this.endPoint = '/activedUser/'+id;
    return await this.put(id,opts); 
  }
  async deleteUser(id,opts={}){
    this.endPoint = '/users';
    return await this.delete(id,opts);
  }
  async toggleUserNotificationStatus(payload) {
    this.endPoint = '/toggle_notification_user';
    return await this.post(payload); 
  }
  async changePassword(payloadUser) {
    this.endPoint = '/change-password';
    return await this.post(payloadUser);
  }
  async registrasi(payload) {
    this.endPoint = '/registrasi';
    return await this.post(payload);
  }
  async changePasswordFromEmail(payload) {
    this.endPoint = '/change_password_from_email';
    return await this.post(payload);
  }
  async verymail(payload) {
    this.endPoint = '/verymail';
    return await this.post(payload);
  }
  async updateUserProfile(payloaduser) {
    this.endPoint = 'update-user-profile';
    return await this.post(payloaduser);
  }
  async uploadImageProfile(data,opts={}) {
    this.endPoint = 'uploadAttachmentUserProfile';
    const newOpts = cloneDeep(opts, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return this.post(data, newOpts)
    // return await this.post(payload);
  }
  async uploadImageSelfie(data,opts={}) {
    this.endPoint = 'uploadAttachmentUserSelfie';
    const newOpts = cloneDeep(opts, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return this.post(data, newOpts)
    // return await this.post(payload);
  }
  async uploadImageIdentitas(data,opts={}) {
    this.endPoint = 'uploadAttachmentUserIdentitas';
    const newOpts = cloneDeep(opts, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return this.post(data, newOpts)
    // return await this.post(payload);
  }
  async uploadImageNPWP(data,opts={}) {
    this.endPoint = 'uploadAttachmentUserNPWP';
    const newOpts = cloneDeep(opts, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return this.post(data, newOpts)
    // return await this.post(payload);
  }
  async updateImageProfile(data,opts={}) {
    this.endPoint = 'updateAttachmentUserProfile/'+data.id;
    const newOpts = cloneDeep(opts, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    
    return this.post(data.data, newOpts)
  }
  async removeImageProfile(id,opts={}) {
    this.endPoint = 'deleteAttachmentUserProfile';
    return await this.delete(id,opts={});
  }
  async verifyEmail(payload, opts={}){
    this.endPoint = 'verymail/'+payload;
    return await this.get(opts);
  }
}

export default new User();
